<ws-modal-wrapper [headerLabel]="headerLabel"
                  [subHeaderLabel]="subHeaderLabel"
                  [isHeaderLink]="isBelowParcelLevel"
                  (headerClick)="loadParentAttachments()"
                  (cancel)="close()"
                  [hideFooter]="true"
                  [isEditing]="editMode"
                  [backdropClick]="true"
                  [loading]="loading"
                  [useAceStyles]="true">
    <div class="row">
        <div [ngClass]="{'col-5': !viewFlags.isViewerFullWidth, 'attachment-list-collapsed': viewFlags.isViewerFullWidth}"
            [hidden]="viewFlags.isListHidden" style="transition: width 0.3s">
            @if (!editMode) {
                <div class="d-flex flex-column" style="gap: 8px;">
                    <div class="d-flex justify-content-between flex-wrap" style="gap: 8px;">
                        <div class="d-flex align-items-center" style="gap: 8px;">
                            <label>Show:</label>
                            <ws-select class="show-control"
                                       [(ngModel)]="yearFilter"
                                       [options]="filteredYears"
                                       labelProperty="name"
                                       valueProperty="value"
                                       [disabled]="isBelowParcelLevel || params.disableYears"
                                       (selectedOptionChanged)="selectFirstAttachment()">
                            </ws-select>
                            <ws-select class="show-control"
                                       [(ngModel)]="categoryFilterId"
                                       [options]="filteredCategories"
                                       labelProperty="category"
                                       valueProperty="attachmentCategoryID"
                                       (selectedOptionChanged)="selectFirstAttachment()"
                                       [disabled]="params.disableCategories">
                            </ws-select>
                            @if (childLabel && !params.showEmailAttachmentButton) {
                                <div class="checkbox">
                                    <label>
                                        <input type="checkbox" [(ngModel)]="includeChildren"
                                               (change)="getAllAttachments()">
                                        Include {{ childLabel }}
                                    </label>
                                </div>
                            }
                        </div>
                        @if (params.canUseCustomOrdering) {
                            <div class="d-flex align-items-center flex-shrink-0" style="gap: 0;">
                                <label for="allowCustomOrdering"
                                       class="mb-0 me-2 text-nowrap"
                                       helpTooltip
                                       helpContentId="attachment-modal.custom-ordering">Allow Custom Ordering</label>
                                <ws-switch id="allowCustomOrdering"
                                           [(ngModel)]="allowCustomOrdering"
                                           [disabled]="params.readOnly || yearFilter !== null || categoryFilterId !== -1"
                                           (selectedOptionChanged)="onAllowCustomOrderingChanged($event)">
                                </ws-switch>
                            </div>
                        }
                    </div>
                    <div class="list-group" [class.list-border]="filteredAttachments.length"
                         style="overflow-y: auto; height: 70vh;"
                         ws-dnd-list
                         [dndList]="filteredAttachments"
                         [dndDisabled]="!allowCustomOrdering || params.readOnly"
                         dndListItemIdProperty="attachmentID"
                         (dndListChange)="onAttachmentsReordered($event)">
                        @for (attachment of filteredAttachments; track attachment) {
                            <a class="list-group-item list-group-item-action d-flex align-items-center"
                               [class.active]="attachment.active"
                               [class.disabled]="attachmentLoading"
                               ws-dnd-draggable
                               [dndDraggable]="attachment"
                               [dndGripHandle]="true"
                               dndEffectAllowed="move"
                               (click)="selectAttachment(attachment)">
                                <div>
                                    @if (includeSubEntities) {
                                        <div>
                                            <strong>{{ attachment.lineOne }}</strong>
                                        </div>
                                    }
                                    <div>
                                        {{ attachment.lineTwo }}
                                    </div>
                                    <div>
                                        {{ attachment.lineThree }}
                                    </div>
                                </div>
                            </a>
                        }
                    </div>
                    @if (!viewFlags.isListHidden && !editMode) {
                        <div class="ace-button-container ws-button-row attachment-modal-actions">
                            @if (allowEntityEdit) {
                                <button class="ace-btn btn-sm btn-primary"
                                        aria-label="Add Attachment"
                                        (click)="addAttachment()">
                                    Add
                                </button>
                            }
                            @if (allowEntityEdit && selectedAttachment) {
                                <button class="ace-btn btn-sm btn-primary"
                                        aria-label="Edit Attachment"
                                        (click)="editAttachment()">
                                    Edit
                                </button>
                            }
                            @if (selectedAttachment) {
                                <button class="ace-btn btn-sm btn-primary"
                                        aria-label="Download Attachment"
                                        (click)="downloadAttachment()">
                                    Download
                                </button>
                            }
                            @if (selectedAttachment && params.showEmailAttachmentButton) {
                                <button class="ace-btn btn-sm btn-primary"
                                        (click)="emailAttachment()">
                                    Email Attachment
                                </button>
                            }
                            @if (canLaunchBundler) {
                                <button class="ace-btn btn-sm btn-primary"
                                        data-qa="launch-bundler"
                                        (click)="launchBundler()">
                                    Attachment Bundler
                                </button>
                            }
                        </div>
                    }
                </div>
            }
            @if (editMode) {
                <attachment-form
                    [attachment]="selectedAttachment"
                    [currentEntity]="currentEntityForForm"
                    [disableYears]="params.disableYears"
                    [defaultYear]="yearFilter"
                    [disableAttachmentType]="params.disableCategories"
                    [attachmentTypeId]="params.attachmentTypeId"
                    [uploadFile]="params.uploadFile"
                    [siteId]="siteIdForAttachmentOperations"
                    (attachmentFormUpdated)="attachmentFormUpdated($event)"
                    (attachmentFormCreated)="attachmentFormCreated($event)"
                    (attachmentFormDeleted)="attachmentFormDeleted()"
                    (attachmentFormCancelled)="attachmentFormCancelled()">
                </attachment-form>
            }
        </div>
        <div [class.invisible]="!selectedAttachment"
             [ngClass]="{'col-7': !viewFlags.isViewerFullWidth, 'col-12': viewFlags.isViewerFullWidth}"
             style="transition: width 0.3s" class="attachment-viewer position-relative">
            @if (file) {
                <div (mouseenter)="hovered = true" (mouseleave)="hovered = false">
                    @if (viewFlags.isViewerFullWidth && filteredAttachments.length > 0 && selectedAttachment) {
                        <div class="preview-nav" [hidden]="!hovered"
                        >
                            <i class="fa fa-arrow-left fa-4x" (click)="getPrev()" [hidden]="isFirstAttachment"></i>
                            <i class="fa fa-arrow-right fa-4x" (click)="getNext()" [hidden]="isLastAttachment"></i>
                        </div>
                    }
                    <div class="preview-window">
                        @if (file) {
                            <file-viewer [file]="file"></file-viewer>
                        }
                    </div>
                </div>
            }
            @if (!file && !attachmentLoading) {
                <div class="d-flex justify-content-center align-items-center" style="height: 90%;">
                    <a class="clickable" (click)="downloadAttachment()">Click to download or view in native
                        application</a>
                </div>
            }
            <div class="d-flex align-items-end justify-content-between attachment-viewer-footer">
                @if (!editMode) {
                    <button class="ace-btn btn-secondary btn-sm has-icon toggle-list"
                            (click)="toggleList()"
                            helpTooltip
                            [helpContentId]="viewFlags.isListHidden ? 'attachment-modal.show-list' : 'attachment-modal.hide-list'">
                        @if (viewFlags.isListHidden) {
                            <i class="fa fa-list"></i>
                        }
                        <i class="fa fa-arrow-left" [hidden]="viewFlags.isListHidden"></i>
                    </button>
                }
                @if (selectedAttachment) {
                    <div class="d-flex justify-content-between align-items-center flex-grow-1"
                         style="margin-left: 10px;">
                        @if (selectedAttachment.createdByLastName) {
                            <div style="font-size: 12px;">
                                Added by: {{ selectedAttachment.createdByLastName }}
                                , {{ selectedAttachment.createdByFirstName }}
                                <abbr
                                    title="{{selectedAttachment.createdDate | date: 'M/d/yyyy h:mm a' : 'america/Chicago' }} CT">{{ displayDate(selectedAttachment.createdDate) }}</abbr>
                            </div>
                        }
                        <div style="font-size: 24px;">{{ selectedAttachment?.lineTwo || 'Preview Window' }}</div>
                        <div class="invisible">Added by: {{ selectedAttachment.createdByLastName }}
                            , {{ selectedAttachment.createdByFirstName }}
                            <abbr>{{ displayDate(selectedAttachment.createdDate) }}</abbr></div>
                    </div>
                }
                <!-- Pop-Out Attachment -->
                @if (selectedAttachment && file) {
                    <div class="btn-group ace-button-container flex-shrink-0" style="margin-left: 10px;"
                         [dropup]="true" dropdown>
                        <button type="button" class="ace-btn btn-sm btn-secondary dropdown-toggle" dropdownToggle>
                            Pop-out
                            <span class="caret"></span>
                        </button>
                        <ul *dropdownMenu class="dropdown-menu" role="menu">
                            <li>
                                <a class="dropdown-item clickable"
                                   (click)="popOutAttachment(true)">Dynamic</a>
                            </li>
                            <li>
                                <a class="dropdown-item clickable"
                                   (click)="popOutAttachment(false)">Static</a>
                            </li>
                        </ul>
                    </div>
                }
            </div>
        </div>
    </div>

</ws-modal-wrapper>
